export default __webpack_public_path__ + "static/media/poster-ondrej.e7944a1a.jpg";